import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-modal-card',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-card.component.html',
})
export class ModalCardComponent {}
